// extracted by mini-css-extract-plugin
module.exports = {"text":"_Footer_text__2BLko","social":"_Footer_social__rKkZY","iconSocial":"_Footer_iconSocial__3FsQJ","icon":"_Footer_icon__2SeBL"};